export default __webpack_public_path__ + "static/media/login_bg_keto@3x.f74492e6.jpg";